import { BookOpen, Users, Heart, Globe, Church, HandHeart, HandHelping, UsersRound, Music, HeartPulse, GraduationCap, Utensils } from "lucide-react";

const iconMap = {
  "hand-heart": HandHeart,
  "book-open": BookOpen,
  "users": Users,
  "heart-handshake": HandHelping,
  "church": Church,
  "hand-holding-heart": HandHeart,
  "globe": Globe,
  "users-round": UsersRound,
  "music": Music,
  "heart": Heart,
  "heart-pulse": HeartPulse,
  "hand-helping-heart": HandHeart,
  "utensils": Utensils,
  "graduation-cap": GraduationCap
};

export const ProgramsSection = ({ programs }) => {
  return (
    <section id="programs" className="py-20 bg-white" data-testid="programs-section">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2
            className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
            data-testid="programs-title"
          >
            Our Programs & Activities
          </h2>
          <div className="w-24 h-1 bg-amber-600 mx-auto mb-6"></div>
          <p
            className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto"
            style={{ fontFamily: "'Crimson Text', serif" }}
          >
            Discover the various ways we serve our community and spread the Gospel
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {programs.map((program, index) => {
            const IconComponent = iconMap[program.icon] || Heart;
            return (
              <div
                key={program.id}
                className="bg-white rounded-xl p-6 hover:shadow-xl transition-all hover:-translate-y-1 border border-gray-200"
                data-testid={`program-card-${index}`}
              >
                <div className="w-14 h-14 bg-amber-600 rounded-full flex items-center justify-center mb-4">
                  <IconComponent className="text-white" size={28} />
                </div>
                <h3
                  className="text-xl font-bold text-gray-900 mb-3"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                  data-testid={`program-title-${index}`}
                >
                  {program.title}
                </h3>
                <p
                  className="text-gray-700 text-sm leading-relaxed"
                  style={{ fontFamily: "'Crimson Text', serif" }}
                  data-testid={`program-description-${index}`}
                >
                  {program.description}
                </p>
                <div className="mt-4 pt-4 border-t border-amber-200">
                  <span className="text-xs font-semibold text-amber-700 bg-amber-100 px-3 py-1 rounded-full">
                    {program.category}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};